module.exports = __webpack_public_path__ + "img/snowman.f1605706.png";